<div class="layout-footer mt-5">
   <!-- <img src="assets/svg/{{layoutService.theme() === 'light' ? 'easypick-dark' : 'easypick-light'}}.svg" alt="Logo" height="20" class="mr-3"/> -->
   <!-- <span class="font-medium ml-2">Easypick</span> -->
   <img src="assets/svg/easypick.svg" alt="Logo" height="20" class="mr-3"/>
   <div class="font-medium">Copyright &copy; {{ getYear }} Easypick</div>
</div>
